import { apiUrl, api } from "../";

const url = `${apiUrl}/kpis/admin`;

export const fetchKpis = () => {
  return api(url, {
    method: "GET",
  });
};
